module.exports = __webpack_public_path__ + "img/person.4e9f7514.svg";